<template>
  <DefaultPage>
    <FilterMain
      v-model="filterQuery"
      @input="debouncedSearch"
      @clear="clearInputSearch"
    >
      <FilterBtn
        type="button"
        class="filter-btn"
        :active-filters="activeFilters"
        @click="filterModalVisible = true"
      />
    </FilterMain>

    <div class="applications-view-wrapper">
      <div v-if="isLoadingApps" class="loading-wrapper">
        <BaseLoadingSpinner :with-overlay="false" :size="60" />
      </div>
      <template v-else>
        <section class="applications-wrapper">
          <SubletApplicationsLane
            title="Inkommande"
            status="new"
            :applications="applicationsNew"
            :container-style="{
              opacity: 0.5
            }"
          ></SubletApplicationsLane>

          <SubletApplicationsLane
            title="Fatta beslut"
            status="waiting"
            :applications="applicationsWaiting"
          ></SubletApplicationsLane>

          <SubletApplicationsLane
            title="Pågående"
            status="approved"
            :applications="applicationsApproved"
          ></SubletApplicationsLane>
        </section>
      </template>
      <router-view />
      <FilterModal
        v-if="filterModalVisible"
        :apps="filteredAhApps"
        :show-swap-filter="false"
        @close="filterModalVisible = false"
      />
    </div>
  </DefaultPage>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import debounce from 'lodash.debounce';

import statusTypes from '@/utils/statusTypes';
import SubletApplicationsLane from '@/components/SubletApplicationsLane.vue';
import FilterMain from '@/components/FilterMain.vue';
import FilterModal from '@/components/FilterModal.vue';
import BaseLoadingSpinner from '@/components/BaseLoadingSpinner.vue';
import DefaultPage from '@/components/DefaultPage.vue';
import FilterBtn from '@/components/FilterBtn.vue';

export default {
  name: 'SubletApplicationsView',
  components: {
    SubletApplicationsLane,
    FilterMain,
    BaseLoadingSpinner,
    FilterModal,
    DefaultPage,
    FilterBtn
  },
  beforeRouteUpdate(to) {
    this.maybeClearInputSearch(to.path);
  },
  beforeRouteLeave(to) {
    //Leaving to new route and unmounting
    this.maybeClearInputSearch(to.path);
  },
  data() {
    return {
      filterQuery: this.$store.state.applications.filter || '',
      filterModalVisible: false
    };
  },
  computed: {
    ...mapGetters({
      filteredAhApps: 'applications/filteredAhApps',
      activeFilters: 'applications/activeFilters'
    }),
    ...mapState('applications', ['isLoadingApps']),
    applicationsNew() {
      if (!this.filteredAhApps) {
        return [];
      }
      return this.filteredAhApps.filter(
        x => x.landlordStatus === statusTypes.INCOMING
      );
    },
    applicationsWaiting() {
      if (!this.filteredAhApps) {
        return [];
      }
      return this.filteredAhApps.filter(
        app => app.landlordStatus === statusTypes.READY
      );
    },
    applicationsApproved() {
      if (!this.filteredAhApps) {
        return [];
      }
      return this.filteredAhApps.filter(
        app => app.landlordStatus === statusTypes.APPROVED
      );
    }
  },
  async created() {
    this.debouncedSearch = debounce(this.search, 300);
    await this.fetchSubletApps();
    // Ladda arkivet i bakgrunden så vi kan räkna matchningar i andra vyn
    this.fetchAhArchivedApps();
    const firstAppId = this.filteredAhApps?.[0]?.id;
    if (firstAppId) {
      await this.fetchLandlordUsersWithUnassigned(firstAppId);
    }
  },

  methods: {
    ...mapActions({
      fetchSubletApps: 'applications/fetchSubletApps',
      fetchAhArchivedApps: 'applications/fetchAhArchivedApps',
      fetchLandlordUsersWithUnassigned:
        'applications/fetchLandlordUsersWithUnassigned'
    }),
    ...mapMutations({
      setFilter: 'applications/setFilter'
    }),
    maybeClearInputSearch(path) {
      // Behåll sökningen inom sublet-modulen (alla/arkiv/annonser)
      if (!path.includes('andrahand')) {
        this.clearInputSearch();
      }
    },
    clearInputSearch() {
      this.filterQuery = '';
      this.debouncedSearch.cancel();
      this.search('');
    },
    search(query) {
      this.setFilter(query);
    }
  }
};
</script>

<style scoped>
.applications-wrapper {
  display: flex;
  flex-direction: row;
  height: 100%;
  max-width: 1080px;
}

.applications-view-wrapper {
  flex: 1;
  margin-left: 20px;
}

.loading-wrapper {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
}
</style>
